import React, { useEffect, useState } from 'react';
import { HungarianStep } from '../solver/hungarian';

interface Props {
  steps: HungarianStep[];
  rowLabels: string[];
  colLabels: string[];
  origRows: number;
  origCols: number;
}

// Visor paso a paso del método húngaro.
const HungarianViewer: React.FC<Props> = ({ steps, rowLabels, colLabels, origRows, origCols }) => {
  const [idx, setIdx] = useState(0);
  useEffect(() => setIdx(0), [steps]);

  if (steps.length === 0) return null;
  const cur = Math.min(idx, steps.length - 1);
  const step = steps[cur];
  const n = step.matrix.length;

  const assignSet = new Set((step.assignment ?? []).map((a) => `${a.row},${a.col}`));

  const label = (arr: string[], i: number, orig: number) =>
    i < orig ? arr[i] ?? `${i + 1}` : 'Fic';

  return (
    <div className="viewer" style={{ ['--accent' as any]: '#7c3aed' }}>
      <div className="viewer-head">
        <h3>Método Húngaro</h3>
      </div>

      <div className="grid-wrap">
        <table className="t-grid hungarian">
          <thead>
            <tr>
              <th className="corner" />
              {Array.from({ length: n }, (_, j) => (
                <th key={j} className={`dest-h ${step.coveredCols?.[j] ? 'covered-col' : ''}`}>
                  {label(colLabels, j, origCols)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {step.matrix.map((row, i) => (
              <tr key={i}>
                <th className={`src-h ${step.coveredRows?.[i] ? 'covered-row' : ''}`}>
                  {label(rowLabels, i, origRows)}
                </th>
                {row.map((val, j) => {
                  const isAssign = assignSet.has(`${i},${j}`);
                  const covered =
                    (step.coveredRows?.[i] ? 1 : 0) + (step.coveredCols?.[j] ? 1 : 0);
                  const cls = [
                    'cell',
                    val === 0 ? 'zero' : '',
                    isAssign ? 'assigned' : '',
                    covered === 2 ? 'cov2' : covered === 1 ? 'cov1' : '',
                  ]
                    .filter(Boolean)
                    .join(' ');
                  return (
                    <td key={j} className={cls}>
                      <span className="hval">{val}</span>
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="step-info">
        <strong>{step.title}</strong>
        <p>{step.description}</p>
      </div>

      <div className="nav">
        <button onClick={() => setIdx(0)} disabled={cur === 0}>
          « Inicio
        </button>
        <button onClick={() => setIdx((i) => Math.max(0, i - 1))} disabled={cur === 0}>
          ‹ Anterior
        </button>
        <span className="counter">
          {cur + 1} / {steps.length}
        </span>
        <button
          onClick={() => setIdx((i) => Math.min(steps.length - 1, i + 1))}
          disabled={cur === steps.length - 1}
        >
          Siguiente ›
        </button>
        <button onClick={() => setIdx(steps.length - 1)} disabled={cur === steps.length - 1}>
          Final »
        </button>
      </div>
    </div>
  );
};

export default HungarianViewer;
